// extracted by mini-css-extract-plugin
module.exports = {"HTMLTextContainer":"HTMLTextContainer_HTMLTextContainer__3YaG4"};